import { IFileAttachment, IMediaFileInfo } from 'AppTypes'
import React from 'react'

type Props = {
  media: string
}

const MenuMedia: React.FC<Props> = ({
  media
}) => (
  <img src={media} alt="" width="" className="rounded" />
)

export default MenuMedia
